import { create } from 'zustand';

import { ApiUtils, HelpersUtils } from '@shared/utils';
import { CardsApi } from '@shared/api/rest';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface DownloadStatementType {
  loading: boolean;
  error: string | null;
  success: boolean | null;
  get: (id: string, token: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadStatementStore = create<DownloadStatementType>((set) => ({
  loading: false,
  error: null,
  success: null,

  get: ApiUtils.wrapperApi(async (id, token, signal) => {
    try {
      set({ loading: true, error: null, success: null });
      const result = await CardsApi.downloadStatement(id, token, signal);
      HelpersUtils.downloadPDFViewByData(result.data!, 'statement', false);
      set({ loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null, success: null }),
}));
